import React from "react";
import { useIntl } from "react-intl";

import Chip from "../../ChipIndicator";

interface IFinanceIndicator {
  filter: any;
}

const defaultValue = {
  type: "none",
  credit: true,
  balloon: true,
  leasing: true,
  deposit: 0,
  mileage: 10000,
  price: [0, 20000],
  rate: [0, 500],
  runTime: 48,
};

const FinanceIndicator = ({
  filter = defaultValue,
}: IFinanceIndicator): JSX.Element | null => {
  const { formatMessage: t, formatNumber: n } = useIntl();
  if (!filter) return null;
  let label = "";
  if (filter.type === "lease") {
    const [from, to] = filter.rate;
    label = t(
      {
        id: "filter.financial.v2.indicator.lease.label",
        defaultMessage:
          "{customerType, select, business {gewerbliche}} Rate: {from,number} - {to,number} €",
      },
      { from, to, customerType: filter.customerType },
    );
    if (filter.deposit > 0) {
      label +=
        " | " +
        t({
          id: "filter.financial.deposit.title.label",
          defaultMessage: "Anzahlung",
        }) +
        ": " +
        t({
          id: "common.upTo",
          defaultMessage: "Anzahlung",
        }) +
        " " +
        n(filter.deposit, {
          maximumFractionDigits: 0,
          style: "currency",
          currency: "EUR",
        });
    }
    if (filter.runTime > 0) {
      label +=
        " | " +
        t({
          id: "common.upTo",
          defaultMessage: "Anzahlung",
        }) +
        " " +
        t(
          {
            id: "filter.financial.runningTime.summary.label",
            defaultMessage: "Laufzeit",
          },
          { value: filter.runTime },
        );
    }
    if (filter.mileage > 0) {
      label +=
        " | min. " + n(filter.mileage, { style: "unit", unit: "kilometer" });
    }
  } else {
    const [from, to] = filter.price;
    label = t(
      {
        id: "filter.financial.v2.indicator.buy.label",
        defaultMessage:
          "{customerType, select, business {gewerblicher} other {}} Kauf: {from,number} - {to,number}€",
      },
      { from, to, customerType: filter.customerType },
    );
  }

  return <Chip id="finance" key="finance" label={label} />;
};

export default FinanceIndicator;
